import React from 'react'

export default (props: any) => (
  <svg {...props} width="66" height="51" viewBox="0 0 66 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22.1405 0.176034L22.091 49.885L43.887 49.9067L43.9364 0.197717L22.1405 0.176034Z" fill="white" />
    <path d="M44.0675 0.226022L44.018 49.935L65.95 49.9568L65.9994 0.24784L44.0675 0.226022Z" fill="#D80027" />
    <path d="M0.195448 0.441018L0.145996 50.15L21.942 50.1717L21.9914 0.462701L0.195448 0.441018Z" fill="#0052B4" />
    <path d="M65.5 0.5H0.5V50.5H65.5V0.5Z" stroke="#9F9D9D" />
  </svg>
)
